export default "__VITE_ASSET__1175dcd5__"